import React from 'react';
import ModuleShell from '@/components/layout/ModuleShell';
import CompliancePage from '@/pages/CompliancePage';
import ComplianceCalendarPage from '@/pages/ComplianceCalendarPage';
import AuditReadinessPage from '@/pages/AuditReadinessPage';
import IncidentsPage from '@/pages/IncidentsPage';
import LedgerPage from '@/pages/LedgerPage';
import PartFPage from '@/pages/PartFPage';
import AuditChainPage from '@/pages/AuditChainPage';
import EmbargoListPage from '@/pages/EmbargoListPage';
import { useAuth } from '@/contexts/AuthContext';

export default function ComplianceModule() {
  const { user } = useAuth();
  const isAdmin = ['platform_owner', 'mga_admin'].includes(user?.role);
  const tabs = [
    { id: 'modules', label: 'Modules', content: <CompliancePage /> },
    { id: 'part-f', label: 'Part F Promises', content: <PartFPage /> },
    { id: 'embargo', label: 'Embargo List', content: <EmbargoListPage /> },
    { id: 'calendar', label: 'Calendar', content: <ComplianceCalendarPage /> },
    { id: 'audit-readiness', label: 'Audit Readiness', content: <AuditReadinessPage /> },
    { id: 'audit-chain', label: 'Audit Chain', content: <AuditChainPage /> },
    { id: 'incidents', label: 'Incidents', content: <IncidentsPage /> },
    // /api/ledger/* is platform_owner / mga_admin only — the tab matches the guard
    ...(isAdmin ? [{ id: 'ledger', label: 'Decision Ledger', content: <LedgerPage /> }] : []),
  ];

  return (
    <ModuleShell title="Compliance" subtitle="Regulatory obligations and reporting" tabs={tabs} />
  );
}
